import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';

import { combineLatest, distinctUntilChanged, map, Observable, Subject, takeUntil } from 'rxjs';

import { ApiloaderService } from './apiloader.service';

interface ApiStatus {
  offline: boolean;
  apiDown: boolean;
  loading: boolean;
}

@Component({
  selector: 'app-apiloader',
  templateUrl: './apiloaderwidget.component.html',
  styleUrls: ['./apiloaderwidget.component.scss'],
  imports:[CommonModule],
  standalone: true
})
export class ApiloaderWidgetComponent implements OnDestroy {
  destroy$ = new Subject<void>();

  readonly apiStatus$: Observable<ApiStatus> = combineLatest([
    this.apiLoaderService.isOffline,
    this.apiLoaderService.isAPIOffline,
    this.apiLoaderService.loading$
  ]).pipe(
    takeUntil(this.destroy$),
    map(([offline, apiDown, loading]) => ({ offline, apiDown, loading })),
    distinctUntilChanged((a, b) =>
      a.offline === b.offline &&
      a.apiDown === b.apiDown &&
      a.loading === b.loading
    )
  );

  constructor(public apiLoaderService: ApiloaderService) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
